<template>
  <form
    class="promocode-card"
    novalidate
    @keyup.enter="onSubmit"
    @submit.prevent="onSubmit"
  >
    <UiText
      class="promocode-card__title"
      color="typography-title01"
      align-center
      font="body-h3"
      :text="$tc('regAuthForgot.regBonus.havePromoCode')"
    />
    <UiAlert
      v-if="alertText"
      class="promocode-card__alert"
      type="error"
      :text="alertText"
      transparent
    />
    <BaseInput
      ref="BaseInputRef"
      v-model="promocodeValue"
      class="promocode-card__input"
      :placeholder="$tc('regAuthForgot.regBonus.typeCode')"
      autocomplete="off"
      text-center
      data-id="promo-card-code-input"
      :maxlength="30"
      :error-messages="errorMessage ? [errorMessage] : []"
      :allow-only-regexp="allowOnlyRegexp"
      :has-error="!!alertText"
      @input="clearError"
    />
    <UiBtn
      class="promocode-card__btn"
      submit
      :text="$tc('regAuthForgot.regBonus.apply')"
      :disabled="isSubmitDisabled"
      :loading="get_promocode.isLoading"
      color="primary"
      data-id="promo-card-code-button"
      size="l"
      @click="onSubmit"
    />
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { PROMOCODE_REASONS } from '~/components/GlobalModals/PromocodeGlobalModal/const'
import { GTM_REG_BONUS } from '~/constants/gtm'

import BaseInput from '~/components/Base/Input'

let intervalId
const PROMO_CODE_SYMBOLS = /^[a-zA-Z0-9!@#$%^&*(){}[\]<>.,\\/?~`=+\-_|"':;]*$/i

export default {
  name: 'PromoCodeCard',
  components: { BaseInput },
  data() {
    return {
      promocodeValue: '',
      errorMessage: '',
      waitTime: 0,
      allowOnlyRegexp: PROMO_CODE_SYMBOLS,
      alertText: '',
    }
  },
  computed: {
    ...mapGetters('promocode-new', ['get_promocode']),
    promocodeBeError() {
      return this.get_promocode.data?.reason
    },
    isHasErrors() {
      return !!this.errorMessage || !!this.alertText
    },
    isSubmitDisabled() {
      return this.isHasErrors || this.get_promocode.isLoading
    },
  },
  beforeDestroy() {
    clearInterval(intervalId)
  },
  methods: {
    ...mapActions('promocode-new', ['send_promocode']),
    ...mapActions('registerBonus', ['actPush_activatedBonusesByPromoCode']),
    updateErrorsBe() {
      this.errorMessage = ''
      this.alertText = ''
      switch (this.promocodeBeError) {
      case PROMOCODE_REASONS.MANY_REQUESTS:
        this.startTimer()
        this.alertText = this.$t('regAuthForgot.regBonus.promocodeErrors.manyRequest', { sec: this.waitTime })
        break
      case PROMOCODE_REASONS.NOT_FOUND:
      case PROMOCODE_REASONS.INVALID_CODE:
        this.alertText = this.$t('regAuthForgot.regBonus.promocodeErrors.bad')
        break
      case PROMOCODE_REASONS.ALREADY_USED:
      case PROMOCODE_REASONS.OVER_ACTIVATIONS:
        this.alertText = this.$t('regAuthForgot.regBonus.promocodeErrors.used')
        break
      }
    },
    updateErrorsFe() {
      this.errorMessage = ''
      this.alertText = ''
      if (!this.promocodeValue.length) return this.errorMessage = this.$t('regAuthForgot.regBonus.promocodeErrors.required')
    },
    handleBePromocodeFail() {
      this.$gtm.push({
        event: GTM_REG_BONUS.EVENT.ga_deposit_click_activate_errors,
        cod: this.promocodeValue,
      })
      this.updateErrorsBe()
      this.$addFocus()
    },
    async onSubmit() {
      this.updateErrorsFe()
      if (this.errorMessage) return
      if (this.alertText) return
      const data = await this.send_promocode({ code: this.promocodeValue })
      if (!data?.status) return this.handleBePromocodeFail()
      
      this.$gtm.push({
        event: GTM_REG_BONUS.EVENT.ga_deposit_click_activate_successful,
        cod: this.promocodeValue,
      })
      this.promocodeValue = ''
      if (data?.includesDepositPromotions) {
        this.$emit('success-register-bonus')
        await this.actPush_activatedBonusesByPromoCode(data?.promotions[0])
      }
      else {
        this.$emit('success-no-deb-bonus')
      }
    },
    startTimer() {
      this.waitTime = this.get_promocode.timeout
      intervalId = setInterval(() => {
        this.waitTime = this.waitTime - 1
        if (this.waitTime < 0) {
          this.waitTime = 0
          clearInterval(intervalId)
          this.alertText = ''
          return
        }
        this.alertText = this.$t('regAuthForgot.regBonus.promocodeErrors.manyRequest', { sec: this.waitTime })
      }, 1000)
    },
    clearError() {
      if (this.waitTime) return
      this.errorMessage = ''
      this.alertText = ''
    },
    $addFocus() {
      this.$refs?.BaseInputRef?.addFocus()
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped />
